export const PENDING_COMPANY_INVITATION_KEY = 'lpam:pending-company-invitation';

const INVITATION_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function invitePathFromHash(hash) {
  return String(hash || '').replace(/^#\/?/, '').split('?')[0];
}

export function invitationIdFromHash(hash) {
  if (invitePathFromHash(hash) !== 'accept-invite') return null;
  const query = String(hash || '').split('?')[1] || '';
  const invitationId = new URLSearchParams(query).get('invitation') || '';
  return INVITATION_ID_PATTERN.test(invitationId) ? invitationId : null;
}

export function preservePendingCompanyInvitation({
  locationLike = globalThis.location,
  storage = globalThis.sessionStorage,
} = {}) {
  const invitationId = invitationIdFromHash(locationLike?.hash);
  if (!invitationId) return null;
  try {
    storage?.setItem(PENDING_COMPANY_INVITATION_KEY, invitationId);
  } catch {
    // The sign-in route remains usable if session storage is unavailable.
  }
  return invitationId;
}

export function loginHrefForCurrentLocation({
  locationLike = globalThis.location,
  storage = globalThis.sessionStorage,
} = {}) {
  const inviteRoute = invitePathFromHash(locationLike?.hash) === 'accept-invite';
  if (inviteRoute) {
    preservePendingCompanyInvitation({ locationLike, storage });
    return `/login?next=${encodeURIComponent('/#/accept-invite')}`;
  }

  const next = typeof locationLike?.href === 'string' && locationLike.href
    ? locationLike.href
    : `${locationLike?.pathname || '/'}${locationLike?.search || ''}${locationLike?.hash || ''}`;
  return `/login?next=${encodeURIComponent(next)}`;
}
